import React, { Component } from 'react'

export default class HeaderBtn extends Component
{
    render()
    {
        return (
            <div className="header_down--btn">
                <button className="btn_getstarted"> GET STARTED </button>
            </div>
        )
    }
}


